/* eslint-disable class-methods-use-this */
class BaseCommand {
  constructor() {
    this.unDoable = true;
    this.redoable = true;
  }

  execute() {
    throw new Error("Method 'execute()' must be implemented.");
  }

  undo() {
    throw new Error("Method 'undo()' must be implemented.");
  }

  scrollIntoView(sectionId) {
    if (sectionId) {
      const element = document.getElementById(
        `document-item-section-${sectionId}`,
      );
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }
  }
}

export default BaseCommand;
